/**
 * 게임 시간 제어: 히트스톱과 슬로모션.
 *
 * 기획서 6장의 Pawfect 슬로모션, 스펙 4장의 착지 히트스톱이 여기 얹힌다.
 * 물리 스텝 자체를 멈추거나 늦추므로, 연출이 물리와 어긋나지 않는다.
 */
export class TimeControl {
  private scale = 1;
  private targetScale = 1;
  private recoverRate = 0;
  private stopRemaining = 0;

  /** 현재 시간 배율. 히트스톱 중에는 0. */
  get currentScale(): number {
    return this.stopRemaining > 0 ? 0 : this.scale;
  }

  get isStopped(): boolean {
    return this.stopRemaining > 0;
  }

  /** 착지 임팩트용 순간 정지. 이미 정지 중이면 더 긴 쪽을 남긴다. */
  hitStop(seconds: number): void {
    this.stopRemaining = Math.max(this.stopRemaining, seconds);
  }

  /** 슬로모션에 진입한 뒤 recoverSeconds에 걸쳐 정상 속도로 복귀한다. */
  slowMotion(scale: number, recoverSeconds: number): void {
    this.scale = scale;
    this.targetScale = 1;
    this.recoverRate = recoverSeconds > 0 ? (1 - scale) / recoverSeconds : Number.POSITIVE_INFINITY;
  }

  /** 즉시 정상 속도로 되돌린다. 레벨 리셋 등에 쓴다. */
  reset(): void {
    this.scale = 1;
    this.targetScale = 1;
    this.recoverRate = 0;
    this.stopRemaining = 0;
  }

  /**
   * 실시간 delta를 게임 시간 delta로 변환한다.
   * 히트스톱 중에는 0을 반환해 물리가 전진하지 않는다.
   */
  advance(realDelta: number): number {
    if (this.stopRemaining > 0) {
      this.stopRemaining -= realDelta;
      return 0;
    }

    if (this.scale < this.targetScale) {
      this.scale = Math.min(this.targetScale, this.scale + this.recoverRate * realDelta);
    }

    return realDelta * this.scale;
  }
}
